module.exports = __webpack_public_path__ + "img/room2.ac62ef76.svg";